import {Component, EventEmitter, Input, OnChanges, OnInit, Output, TemplateRef, ViewChild, ViewContainerRef } from '@angular/core';
import {DemoService} from '../../../demo.service';
import { HotToastService } from '@ngneat/hot-toast';
import {Routes, RouterModule, Router, ActivatedRoute} from '@angular/router';

// import { Job } from '../../../shared/models/job.model';
import { DatePipe } from '@angular/common';

import { enableRipple } from '@syncfusion/ej2-base';
// enable ripple effects
enableRipple(true);
import { DataManager, ODataAdaptor, WebApiAdaptor, UrlAdaptor,Query, ReturnOption, DataUtil  } from '@syncfusion/ej2-data';
import { MenuItemModel } from '@syncfusion/ej2-angular-navigations';
import { PageSettingsModel, FilterSettingsModel } from '@syncfusion/ej2-grids';

import { ChangeEventArgs } from '@syncfusion/ej2-inputs';
import { createElement } from '@syncfusion/ej2-base';
import {  IFilter } from '@syncfusion/ej2-angular-grids';
import { GridComponent, ToolbarItems, ToolbarService, ExcelExportService, GroupSettingsModel,
RowDataBoundEventArgs  } from '@syncfusion/ej2-angular-grids';
import { ClickEventArgs } from '@syncfusion/ej2-angular-navigations';


import { FilterService, IFilterUI, Column } from '@syncfusion/ej2-angular-grids';
import { DatePicker } from '@syncfusion/ej2-calendars';
import { parentsUntil } from '@syncfusion/ej2-grids';
import { HttpClient } from '@angular/common/http';
import { GlobalFunctionsService } from './../../../services/global-functions.service';
import { Observable, delay, retry } from 'rxjs';
import { BsModalService } from 'ngx-bootstrap';
import { MysqlService } from '../../../services/mysql.service';
import { Brand } from './../../../shared/models/brand.model';
import { SubjectInvoiceItem } from './../../../shared/models/subjectInvoiceItem.model';
import { MyobServiceInvoice } from './../../../models/myob-service-invoice.model';
import { SubjectInvoice } from './../../../shared/models/subjectInvoice.model';
import { Payment } from './../../../shared/models/payment.model';
import { MyobServicePaymentInvoice } from './../../../models/myob-service-invoice-payment.model';
import { NgForm } from '@angular/forms';

// Using Loadash in Angular
// ::@ https://edupala.com/how-to-use-lodash-in-angular/
import * as _ from 'lodash';

@Component({
  selector: 'app-payments-grid-invoice',
  templateUrl: './payments-grid-invoice.component.html',
  styleUrls: ['./payments-grid-invoice.component.scss']
})
export class PaymentsGridInvoiceComponent implements OnInit {



  @Input() brand_id?: Observable<any[]>; 
  @Input() job_status_code?: Observable<any[]>; 
  @Input() assigned_agent?: Observable<any[]>;  // single agent brand_id lookup
  
  @Input() job_id?: Observable<any[]>;
  @Input() subject_id?: Observable<any[]>; 
  
     // setup as observable?
     @Input() item_id?: Observable<any[]>; // impliments on changes. // Base set to Job_ID
     @Input() item_data?: Observable<any[]>; // if data.model is sent : Observable<any[]>;
     @Input() use_item_data? = 'no'; // if data.model is sent use this instead of item_id
     
     @Input() item_user_level_id? = '5'; // default to agent just in case
     @Input() item_brand_type_id? = null;
     @Input() item_brand_id? = null;
     @Input() item_subject_id? = null;
     @Input() item_subject_number? = '';
     
     @Input() show_buttons? = 'no'; // yes | no
     @Input() item_title? = '';
     @Input() widget_size? = 'side'; // side | abstract | full



  @Input() subject_number;
  @Input() job_number;

  @Input() is_create_invoice_item =  false; // false by defualt... now make the component work for both invoices and stand alone.
  @Input() is_update_invoice_item =  false; // false by defualt... now make the component work for both invoices and stand alone.
  @Input() invoice_id?; // impliments on changes.
  @Input() invoice_number?; // impliments on changes.

  // setup as observable?

  @Input() widget_title? = '';


  @Output('closeParentModel2') closeParentModel2: EventEmitter<any> = new EventEmitter();
  @Output('closeParentModel3') closeParentModel3: EventEmitter<any> = new EventEmitter(); // simple close window
  @Output('refreshParentGrid') refreshParentGrid: EventEmitter<any> = new EventEmitter();
  @Output('refreshInvoiceItemsBelow') refreshInvoiceItemsBelow: EventEmitter<any> = new EventEmitter();

  @Input() payment_id?;

  @Output('refreshSujectInvoicePage') refreshSujectInvoicePage: EventEmitter<any> = new EventEmitter();
     // access the template form
     @ViewChild('invoicePaymentForm') invoicePaymentForm: NgForm;


     
  
   // Grid Vars
   public data: DataManager;
   public data_subjects: DataManager;
   public pageSettings: Object;
   public pageOptions = { pageSize: 100 }; 
   public filterOptions: FilterSettingsModel;
   public formatOptions: Object;
   // public filterOptions: FilterSettingsModel;
   public filter : IFilter;
   public toolbarOptions: ToolbarItems[];
   @ViewChild('grid')
   public grid: GridComponent;
   public groupOptions: GroupSettingsModel;
   public templateOptionsDate: IFilterUI;
   public elem1: HTMLElement;
   public datePickerObj: DatePicker;
   subjects_urgent: any;
   formatoptions: { type: string; format: string; };
   dateFormat: string;
   sortOptions: { columns: { field: string; direction: string; }[]; };
   
   today = new Date().toISOString(); // this date worked to compare dates with ZISo date format in database.
   // today_set = new Date(); // sets todays date
   // today = this.datepipe.transform(this.today_set, 'dd/MM/yyyy h:mm a'); // formats date for comparison
  
   initialPage: { pageSize: number; };
   open_jobs_count: any;
    all_router_details: string;
    sessionUserId: any;
    sessionUsername: any;
    sessionBrandId: any;
    invoices: any;
    modalRef: any;
    myobInvoiceCreatedData: any;
    myobInvoiceListMapped: any;
    set_RowVersion: any;
    brand: any;
    brandData: any;
    data_invoice: any = MyobServiceInvoice;
    data_payment: any = MyobServicePaymentInvoice;
    myobInvoices: Object;
    arrCase: object[];
    Items: any;
    myobInvoiceDeleteData: Object;
    myobInvoice: Object;
    invoiceItem: any;
    invoiceItemsList: any = SubjectInvoiceItem;
    
    myob_account_codes: Object;
    myob_tax_codes: Object;
    myobInvoiceUpdateData: any;
    myobInvoiceUpdatedData: any;
  
    invoice_model: SubjectInvoice = new SubjectInvoice();
    invoice_item_model: any = SubjectInvoiceItem;
    invoiceItemUpdateList: any;
    new_line: {};


  payments: any;
  paymentItemsList: any;
  payment_item_model: any = SubjectInvoiceItem;
  myobPaymentCreatedData: any;
  myobPaymentListMapped: any;
  myobPaymentDeletedData: Object;
  payments_metrics: Object;
  myob_payments_live: Object;
  sent_data: any;
  difference_payment_data: unknown[];
  
    constructor(private http: HttpClient, private router: Router,
      private route: ActivatedRoute, private _demoService: DemoService,
     public datepipe: DatePipe,
     public gfunc: GlobalFunctionsService,
     private modalService: BsModalService,
     public toastr: HotToastService,
     vcr: ViewContainerRef,
     private _mysqlService: MysqlService,) { 
  
       // Set and Access login Session Variables
   this.gfunc.setLoginSessionVars(); // set in a global function file
   this.sessionUserId = this.gfunc.currentUserVAR.user_id;
   this.sessionUsername = this.gfunc.currentUserVAR.username;
   this.sessionBrandId = this.gfunc.currentUserVAR.brand_id;
  
        // need to add this as routes does not work globally
        this.all_router_details = this.router.url;
        this.gfunc.current_base_route = this.router.url.substr(0, this.all_router_details.lastIndexOf('/'));
  
      // Grid Options
      this.toolbarOptions = ['Search'];
      this.initialPage = { pageSize: 40 };
      this.filterOptions = {
         type: 'Menu'
      };
  
    // this.groupOptions = { columns: ['job_id'] }; // sets auto grouping for the grid
      this.groupOptions = { }; // sets auto grouping for the grid
  
      this.formatoptions= {type:'date', format:'dd/MM/yyyy'};
      this.dateFormat = 'dd/MM/yyyy hh:mm a';
       //this.filter = { params: { format: this.dateFormat } };
      this.sortOptions = { columns: [{ field: 'payment_id', direction: 'Descending' } ] };
  
     }
  
    ngOnInit() {
      // this.getPayments();

      // this.getMyobTaxCodes(); // load for merge variables arrays
      // this.getMyobAccountCodes();
  
  
      
    }
  
    ngOnChanges(changes) {

      this.invoice_number = changes.invoice_number.currentValue;

      if (changes.invoice_id) {
        // deal with asynchronous Observable result
    this.invoice_id = changes.invoice_id.currentValue;

    let search_model = {
      invoice_id: this.invoice_id
    }

    this.getPaymentsMetrics(search_model);

    this.getMyobCustomerPaymerntsLive() //auto filtered for invoice_number ---

    this.getMyobTaxCodes(); // load for merge variables arrays
    this.getMyobAccountCodes();


      }

  
  // this.getInvoices();
  
  //     if (changes.subject_id) {
  //       // deal with asynchronous Observable result
  //   this.subject_id = changes.subject_id.currentValue;
  // //  this.getSubjectInvoices(this.subject_id);
  //   //  this.getBrandJobsTableDataGrid(this.brand_id, this.job_status_code, this.assigned_agent);
  // };
  
   // this.getInvoices();
  
    };
  
  
  // Setup the SyncFusion GRID
  
  
  toolbarClick(args: ClickEventArgs): void {
    if (args.item.id === 'Grid_excelexport') { // 'Grid_excelexport' -> Grid component id + _ + toolbar item name
        this.grid.excelExport();
    }
  }
  rowDataBound(args: RowDataBoundEventArgs) {
    const job_status = 'payment_status';
    if (args.data[job_status] === 'OVERDUE') {
        args.row.className = 'text-danger';
    }
  }
  
  
  jobLink(job_id) {
    this.router.navigate(['/admin/jobs/create-job-3/' + job_id + '']);
  }
  
  jobView(job_id) {
    this.router.navigate(['/admin/jobs/view/' + job_id + '']);
  }
  
  subjectEdit(subject_id){
    this.router.navigate(['/admin/jobs/subject/edit/' + subject_id + '']);
  }
  
  
  refreshGrid(){ // refresh the databutton
   // this.getBrandJobsTableDataGrid(this.brand_id, this.job_status_code, this.assigned_agent);
  //  this.getPayments();


  let search_model = {
    invoice_id: this.invoice_id
  }
  
  this.getMyobCustomerPaymerntsLive() //auto filtered for invoice_number ---
  this.getPaymentsMetrics(search_model);

    this.grid.refresh();
  };
  
  

  getPayments() {
    this._demoService.getPayments().subscribe(
       data => { this.payments = data; },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   } 

   getPaymentsMetrics(search_model) {
    this._demoService.getPaymentsMetrics(search_model).subscribe(
       data => { this.payments_metrics = data; 
        this.payments = data; 
      },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   } 
  

   

  getInvoices() {
    this._demoService.getInvoices().subscribe(
       data => { this.invoices = data; },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }
  
   getSubjectInvoices(subject_id) {
    this._demoService.getSubjectInvoices(subject_id).subscribe(
       data => { this.invoices = data; }, // make the same data call for all
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }
  
  
  getBrandJobsTableData(brand_id) {
    this._demoService.getBrandJobsTableData(brand_id).subscribe(
      data => { this.subjects_urgent = data;
        this.open_jobs_count = this.subjects_urgent.length;
        // pass so that the dates are correct in Sync
        // WORKED https://www.syncfusion.com/forums/152967/no-filter-result-using-date-column-in-ejs-grid-angular
        this.subjects_urgent = DataUtil.parse.parseJson(data); 
       // console.log("Done loadng USER");
       // console.log(this.users);
  
  
      },
      error => {
      //  console.error('Error Loading User!');
      // return Observable.throw(error);
      }
    ); }
  
    getBrandJobsTableDataGrid(brand_id, job_status_code, assigned_agent) {
      this._demoService.getBrandJobsTableDataGrid(brand_id, job_status_code, assigned_agent).subscribe(
        data => { this.subjects_urgent = data;
  
        let res = data;
  
          // removes all words with length of > 6
         // const result = this.subjects_urgent.filter(word => this.subjects_urgent.length > 6);
  
         if (this.gfunc.sessionUserLevel === '9' ) { //client - remove these columns
         // let result_filter = this.subjects_urgent.filter(subject => this.subjects_urgent.job_type_id);
         // res.filter( e => this.subjects_urgent.allocated_to);
         // send results back to array.
        // this.subjects_urgent = result_filter;
         }
  
  
          this.open_jobs_count = this.subjects_urgent.length;
          // pass so that the dates are correct in Sync
          // WORKED https://www.syncfusion.com/forums/152967/no-filter-result-using-date-column-in-ejs-grid-angular
          this.subjects_urgent = DataUtil.parse.parseJson(data); 
         // console.log("Done loadng USER");
         // console.log(this.users);
    
    
        },
        error => {
        //  console.error('Error Loading User!');
        // return Observable.throw(error);
        }
      ); }
  
  
  
  // https://ej2.syncfusion.com/angular/documentation/grid/tool-bar/#built-in-and-custom-items-in-toolbar
  clickHandler(args: ClickEventArgs): void {
    if (args.item.id === 'Click') {
  
    //  this.grid.showSpinner();
  
    //    alert('This function will trigger the action to Emails, and Status Notifications to Agents');
   //  console.log(args.data.items);
   
  
  
    let pdfdata;
    const query = this.grid.renderModule.data.generateQuery(); // get grid corresponding query
    for (let i = 0; i < query.queries.length; i++) {
      if (query.queries[i].fn === 'onPage') {
        query.queries.splice(i, 1);       // remove page query to get all records
        break;
      }
    }
    const fdata = new DataManager({ json: this.subjects_urgent }).executeQuery(query).then((e: any) => {
      pdfdata = e.result as object[];  // get all filtered records
      const exportProperties = {
        dataSource: pdfdata,
      };
      //console.log(pdfdata.results);
      
     // this.search_results = pdfdata.records; // need this if a grouping is set.
    /*   this.search_results = pdfdata;
      this.toastr.info( this.search_results.length + ' subjects added to the update Request Que'); 
      this.toastr.success( "Press Start To Process Que");  */
     // this.grid.pdfExport(exportProperties);
    }).catch((e) => true);
    }
  
   //  this.grid.hideSpinner();
  
  };
  
  
  
  
  // End Grid Items and Setup
  
  
  
  
  
  
  
    
   // MODAL
  // start of modal windows service as a template
  openModal(template: TemplateRef<any>) {
    // small upgrade to disable background click on open modal background
    const config = { backdrop: true, ignoreBackdropClick: true, class: 'gray modal-lg' };
    this.modalRef = this.modalService.show(template, config);
  }
  
  // :: Parent / Child modal test
  closeParentModel() {
    // alert('parent component function.');
    this.modalRef.hide();
   // this.refreshGrid(); // resets the grid if updated and closed.
  //  this.updateTypeClick = false; // closes the div
  };
  
  
   getBrand(brand_id) {
    this._demoService.getBrandById(brand_id).subscribe(
    data => { this.brand = data;
    let  res = data;
    this.brandData = res;
    },
     err => console.error(err),
     () => console.log('Brand Loaded.')
   );
  }
  
  
  
  // :: Sart of myob
  
  
  // delay function
  delay(ms: number) {
    return new Promise( resolve => setTimeout(resolve, ms) );
  }
  
  

  
    setMyobPaymentModelStep1(model){
  this.getInvoicePaymentsByPaymentIDStep(model.payment_id, model);
    };
  

  // Get Invoice Payment Items
  getInvoicePaymentsByPaymentIDStep(payment_id, model){
    this._demoService.getInvoicePaymentsByPaymentID(payment_id).subscribe(
      (data) => {
        this.paymentItemsList = data;
        let res = data[0];
        this.payment_item_model = this.paymentItemsList;
        this.setMyobPaymentModelStep2(model); // ru
        // console.log('PaymentItemsList: ' + JSON.stringify(this.payment_item_model));
        // this.doCalculations();
      },
      (err) => console.error(err),
     () => console.log('Payment Invoices Items Loaded.')
    )};
  
  

  
  // :: Create Payment.
  setMyobPaymentModelStep2(model){
// this is who made the payment details.
   this._demoService.getBrandById(model.to_brand_id).subscribe(
     data => { this.brand = data;
     const  resBrand = data[0];
                       this.brandData = resBrand;
                 console.log('Brand MyobID: ' + resBrand.myob_id);
                 console.log('Brand ID MYOB: ' + this.brandData.myob_id);
                //  console.log('Payment Items Invoices: ' + JSON.stringify(this.payment_item_model));
                 // Model.- use return so that model is available in the outside subscription
                
// Meed to get a model of the Tax Code ID
// Memo if a subject or job invoice
// let JournalMemo;
// if (model.is_job_invoice >= 1) {
//  JournalMemo = 'Job Invoice';
// }else{
//  JournalMemo = 'Subject Invoice';
// };

// let BillDeliveryStatus;
// if (model.invoice_communication_status_id === 1) { // email
//  BillDeliveryStatus = 'Nothing';
// }else{
//  BillDeliveryStatus = 'Print';
// }

/*
Payment POST
*/
// get the account code.
let paymentAccountUID = Object(this.myob_account_codes).filter((mac)=>(mac.myob_account_code_id === model.myob_account_code_id ));
let setMaymentAccount = paymentAccountUID[0].myob_account_id;
                  this.data_payment = {
                    'PayFrom': 'Account',
                    'Account': {
                      'UID': setMaymentAccount
                    },
                    'Customer': {
                      'UID': this.brandData.myob_id
                    },
                    'PayeeAddress': '',
                    'StatementParticulars': '',
                    'PaymentNumber': '1',
                    'Date': model.payment_date,
                    'AmountPaid': model.payment_total,
                    'Memo': 'SOP Payment; ' + this.brandData.name + ' SPID:' + model.payment_id,
                    'Invoices': [
                    //   {
                    //   'UID': '49dd6a4b-5b99-479d-8022-094f336da2d7',
                    //   'AmountApplied': 46.2,
                    //   'Type': 'Invoice'
                    // }
                  ],
                    'DeliveryStatus': 'Print',
                    'ForeignCurrency': null
                  };

                    // tslint:disable-next-line:max-line-length (these are Invoices)
                    let newArr = Object(this.payment_item_model).filter((sbi)=>(1===1)); // sbi.invoice_status === 'NOT-INVOICED'- old filter
                    let  count_of_items = Object.keys(newArr).length;

                    for(let i=0;i < count_of_items; i++) {
                    let res = newArr[i];

                   let new_line = {

                      'UID': res.myob_id,  // has to be an invoice ID code
                      'AmountApplied': model.payment_total,
                      'Type': 'Invoice'
                     };

                 this.data_payment.Invoices.push(new_line);
                 }

                 console.log('New Pushed Model: ' + JSON.stringify(this.data_payment));


     },
     err => console.error(err),
     () =>  {
       console.log('payment model Loaded.');
     this.createMyobPaymentModel(model, this.data_payment);

     }
   );
    }

  
 createMyobPaymentModel(model, data_payment){
  // if (confirm('We are about to Sync this Payment and Items with MYOB, This will close all invoices local and Myob Cloud. Are you Sure?')) {
// console.log('Payment Data: ' + JSON.stringify(data_payment));

// :: Ideally need to get a response from insert of the UID of the customer to insert back in sop brands to know th e link has taken place.
if (this.data_payment != '{}' ) {
    this._demoService.createMyobPayment(this.data_payment).subscribe(
    data => { this.myobPaymentCreatedData = data;
      let res = data[0];
      let new_data_object = JSON.parse(this.myobPaymentCreatedData);


      let location_string = new_data_object.location;
      // get everything after last dash 
      let slug = location_string.split('/').pop(); // 2020
      console.log('UUID slug: ' + slug);

                  // model.myob_id = slug;
                  // model.sync_with_myob = 1;
                  // this.updateSubjectInvoice(model);
                  // this.editBrand(model);
                  // this.refreshGrid();
                  // this.toastr.info('Invoice Upgraded In SOP');

      // :: Need to lookup myoub get UID/myobid and fill rest of model.vars.
                // need to pass the brand model here as its updatting the full SOP brand details.
                this._demoService.getMyobPaymentsMapped(slug, model).subscribe(
                   data4 => {
                    console.log(data4);
                    res = data4[0];
                  // many
                    // this.myobContactListMapped = data.data;
                  //single
                    this.myobPaymentListMapped = data4;
                  // Set the returned Variables Reququied for Update of a Myob Customer.
                  console.log('UID: ' +  data4.UID);
                  console.log('LastModified: ' + data4.LastModified);
                  console.log('RowVersion: ' + data4.RowVersion);
                  // console.log('TaxCodeUID: ' +  data4.SellingDetails.TaxCode.UID);
                  // console.log('Sale Layout: ' +  data4.SellingDetails.SaleLayout);


                  // work out the nulls for sub arraryas
                  // let CategoryUID;
                  // let OrderUID;
                  // let SalespersonUID

                  // if (typeof model.Category === 'undefined' || model.Category === null ) {
                  //   CategoryUID = null;
                  // }else {
                  //   CategoryUID = model.Category.UID; // can only call if actuall exist in the array!
                  // };
                  // if (typeof model.Order === 'undefined' || model.Order === null ) {
                  //   OrderUID = null;
                  // }else {
                  //   OrderUID = model.Category.UID; // can only call if actuall exist in the array!
                  // };
                  // if (typeof model.Salesperson === 'undefined' || model.Salesperson === null ) {
                  //   SalespersonUID = null;
                  // }else {
                  //   SalespersonUID = model.Category.UID; // can only call if actuall exist in the array!
                  // };


                  this.set_RowVersion = data4.RowVersion;

                // All Additional Myon Invoice Payment Variables
                  model.UID = data4.UID;
                  model.DepositTo = data4.DepositTo;
                  model.AccountUID = data4.Account.UID;
                  model.CustomerUID = data4.Customer.UID;
                  model.URI = data4.URI;
                  model.myob_array = JSON.stringify(data4);
                  model.RowVersion = data4.RowVersion;
                  model.myob_id = slug;
                  model.sync_with_myob = 1;
                  


                  // Now Update All invoices Paid.
                  // Mow also need to pull and upate the invoice detauls as a function.
                  let newArr = Object(this.payment_item_model).filter((sbi)=>(1===1)); // sbi.invoice_status === 'NOT-INVOICED'- old filter
                  let  count_of_items = Object.keys(newArr).length;
                  for(let i=0;i < count_of_items; i++) {
                  let res = newArr[i];

                    console.log('Invoice to Update: ' + res.UID);
                  this.lookupInvoiceUpdateInvoice2(res.myob_id, data);
                  } // end invoices paid that changed.

                  // Now run the payment records
                  this.updatePayment(model);  // updates the payment record.
                  this.toastr.info('Invoice Payments + Items Vrs Upgraded In SOP');
                  this.refreshGrid();
                },
                error => {
                  // console.error('Error saving Event!');
                   this.toastr.error('Error Updating Invoice Payment(s) to Myob Details');
                  console.log(error.error);
                 });


                //  model.RowVersion = this.set_RowVersion;


                  
                    //  model.RowVersion = this.set_RowVersion;
                //  model.myob_customer_array = JSON.stringify(this.myobContactListMapped);


      // let new_data_string = JSON.stringify(this.myobCustomerCreatedData);
      // console.log('new_data date: ' + new_data_string.date);
      // console.log('new_data date: ' + new_data_string.location);

      // console.log(this.myobCustomerCreatedData.location);
      // // https://www.concretepage.com/questions/577
      //  this.arrCase = data as object [];  // FILL THE ARRAY WITH DATA.
      //  // console.log(this.arrCase);
      //  this.Items = data['Items'] ;
      // this.toastr.info('Payment + Returned Items Upgraded In SOP');
    
    },
    err => {
      // this.toastr.error('You need to login to MYOB again, Connection lost!');
     console.log(err.error);
    },
    // () => console.log('done loading Trace Types')
  );
}// end if invoice_data

  // }; // end confirm

};


updatePayment(model){
  this._demoService.updatePayment(model).subscribe(
    data => {  // this.new_invoice_id = data; // this is the retuned json upon creation.
      // let res = data[0];
    // this.router.navigate(['../../companies'], { relativeTo: this.route });
  this.toastr.success('Local Payment Datas Updated');
     return true;
    },
    error => {
      console.log(error.error);
   //  this.toastr.error('Adding Failed :: Please try again!');
     // console.log(Observable.throw(error));
      // return Observable.throw(error);
    }
    );
     };




  // Get Invoice Payment Items
  getInvoicePaymentsByPaymentID(payment_id){
    this._demoService.getInvoicePaymentsByPaymentID(payment_id).subscribe(
      (data) => {
        this.paymentItemsList = data;
        let res = data[0];
        this.payment_item_model = this.paymentItemsList;
        // this.setMyobPaymentModelStep2(model); // ru
        // console.log('PaymentItemsList: ' + JSON.stringify(this.payment_item_model));
        // this.doCalculations();
      },
      (err) => console.error(err),
     () => console.log('Payment Invoices Items Loaded.')
    )};





getMyobAccountCodes() {
  this._demoService.getMyobAccountCodes().subscribe(
     data => { this.myob_account_codes = data;
      let res = data[0];
    },
     err => console.error(err),
     // () => console.log('done loading Trace Types')
   );
 }

 getMyobTaxCodes() {
  this._demoService.getMyobTaxCodes().subscribe(
     data => { this.myob_tax_codes = data;
      let res = data[0];
    },
     err => console.error(err),
     // () => console.log('done loading Trace Types')
   );
 }



  updateMyobInvoiceModelStep1(model){
    this.getUpdateInvoiceItmes(model.invoice_id, model);
      };
  
   // Get Invoice Items
  getUpdateInvoiceItmes(invoice_id, model){
    this._demoService.getSubjectInvoiceItems(invoice_id).subscribe(
      (data) => {
        this.invoiceItemsList = data;
        let res = data[0];
        this.invoice_item_model = this.invoiceItemsList;
        // this.setMyobInvoiceModelStep2(model); // ru
        this.updateMyobInvoiceModelStep2(model);
        // this.doCalculations();
      },
      (err) => console.error(err),
     () => console.log('Invoice Items Loaded.')
    )};
  
  
  
    updateMyobInvoiceModelStep2(model){
      this._demoService.getBrandById(model.to_brand_id).subscribe(
        data => { this.brand = data;
        const  res = data[0];
                          this.brandData = res;
                    console.log('Brand MyobID: ' + res.myob_id);
                    console.log('Brand ID MYOB: ' + this.brandData.myob_id);
                    console.log('Invoice Items: ' + JSON.stringify(this.invoice_item_model));
                    // Invoice Model.- use return so that model is available in the outside subscription
                   
   // Memo if a subject or job invoice
   let JournalMemo: string;
   if (model.is_job_invoice >= 1) {
     JournalMemo = 'Job Invoice';
   }else{
     JournalMemo = 'Subject Invoice';
   };
   
   let BillDeliveryStatus: string;
   if (model.invoice_communication_status_id === 1) { // email
     BillDeliveryStatus = 'Nothing';
   }else{
     BillDeliveryStatus = 'Print';
   }
   
   // NEed tp add the extra update records and IDS in model
   
                    this.data_invoice = {
                   'UID': model.UID, // update fields for model 
                   'RowVersion': model.RowVersion, // update
   
                    'Number': model.invoice_number, //  model.invoice_number
                    'Date': model.date_created,
                    'SupplierInvoiceNumber': null,
                    'Customer': {
                    'UID': this.brandData.myob_id
                    },
                    'ShipToAddress': '' ,
                    'Terms': {
                    'PaymentIsDue': 'DayOfMonthAfterEOM',
                    'DiscountDate': 1,
                    'BalanceDueDate': 30,
                    'DiscountForEarlyPayment': 0,
                    'MonthlyChargeForLatePayment': 0,
                    'DiscountExpiryDate': model.due_date,
                    'Discount': 0,
                    'DueDate': model.due_date
                    },
                    'IsTaxInclusive': true,
                    'IsReportable': true,
   
                    'Lines': [
                    // {
                    // 'Type': '',
                    // 'Description': '' ,
                    // 'Account': {
                    // 'UID': 'd92626b4-1cbb-4ac9-8b46-856175f5c0a7'
                    // },
                    // 'Total': 6,
                    // 'Job': null,
                    // 'TaxCode': {
                    // 'UID': '8d273078-fe1d-4c16-b318-ec7a2b7fb2fe'
                    // }
                    // },
                    ],
   
                    'Subtotal': model.invoice_subtotal,
                    'Freight': 0,
                    'FreightTaxCode': {
                    'UID': this.gfunc.myob_FreightTaxCode
                    },
                    'TotalTax': model.invoice_gst,
                    'TotalAmount': model.invoice_total,
                    'Category': null,
                    'Comment': '',
                    'ShippingMethod': null,
                    'PromisedDate': null,
                    'JournalMemo': 'SOP: ' + JournalMemo + ' ' + model.invoice_number,
                    'BillDeliveryStatus': BillDeliveryStatus,
                    'AppliedToDate': 0,
                    'BalanceDueAmount': model.invoice_remaining_total,
                    'Status': 'Open',
                    'LastPaymentDate': null,
                    'Order': null,
                    'ForeignCurrency': null
                    };
   
   
   
                        // :: This function Collects and pushes the lines to the rows of the invoice.
                    // console.log('Invoice Items: 2 ' + JSON.stringify(this.invoiceItemsList));
                    // need to loop through the invoice model and create Lines.
   
                    let newArr = Object(this.invoice_item_model).filter((sbi)=>(1===1)); // sbi.invoice_status === 'NOT-INVOICED'- old filter
   
                    let  count_of_items = Object.keys(newArr).length;
                    //  let res = data[0];
                    // Run the job data queries.
                    // need to do a loop of subject_billing items (.length)
                    for(let i=0;i < count_of_items; i++) {
                      let res2 = newArr[i];
   
   
                       // get a list of all the account ID/s in an array  -- THIS WORKS SO WELL!!!!!!
                                     // this.getMyobTaxCodes(); // load this onInit.
                                     // this.getMyobAccountCodes();
                     const retTaxCodeUID = Object(this.myob_tax_codes).filter((mtc)=>(mtc.myob_tax_code_id === res2.myob_tax_code_id ));
                     const retAccountUID = Object(this.myob_account_codes).filter((mac)=>(mac.myob_account_code_id === res2.myob_account_code_id ));
                     // console.log('Tax Acc: ' + JSON.stringify(retTaxCodeUID));
                     // console.log('Myob Acc: ' + JSON.stringify(retAccountUID));
   
                     let TaxAccountUID = retTaxCodeUID[0].UID;
                     let MyobAccountUID = retAccountUID[0].UID;
   
                     console.log('Tax Code: ' + retTaxCodeUID[0].UID);
                     console.log('Acc Code: ' + retAccountUID[0].UID);
   
   
                     //  let new_line = {
                     //    'RowID': res.RowID, // requored update
                     //    'RowVersion': res.RowVersion, // required Update
                     //    'Type': 'Transaction',
                     //    'Description': res.billing_task_name,
                     //    'Account': {
                     //    'UID': MyobAccountUID,
                     //    },
                     //    'Total': res.total,
                     //    'Job': null,
                     //    'TaxCode': {
                     //    'UID': TaxAccountUID
                     //    }
                     //    };
   
                     this.new_line = null; // reset
   
                     // :: Determine to update row or insert new if Lines.RowID exista
   
                     if(res2.RowID != null) {
                     this.new_line = {
                       'RowID': res2.RowID, // requored update
                       'RowVersion': res2.RowVersion, // required Update
                       'Type': 'Transaction',
                       'Description': res2.billing_task_name,
                       'Account': {
                       'UID': MyobAccountUID,
                       },
                       'Total': res2.total,
                       'Job': null,
                       'TaxCode': {
                       'UID':  TaxAccountUID
                       }
                       };
                     }; // end update line
   
                     if (res2.RowID == null) {
                       this.new_line = {
                         // 'RowID': res2.RowID, // requored update
                         // 'RowVersion': res2.RowVersion, // required Update
                         'Type': 'Transaction',
                         'Description': res2.billing_task_name,
                         'Account': {
                         'UID': MyobAccountUID,
                         },
                         'Total': res2.total,
                         'Job': null,
                         'TaxCode': {
                         'UID':  TaxAccountUID
                         }
                         };
                       }; // end new line.
   
   
                    this.data_invoice.Lines.push(this.new_line);
                    }
   
                    console.log('Update Pushed Model: ' + JSON.stringify(this.data_invoice));
   
   
        },
        err => console.error(err),
        () =>  {
          console.log('invoice model Loaded.');
        this.updateMyobInvoiceModel(model, this.data_invoice);
        }
      );
       
        //   await this.delay(3000);
        //  })(); // end async function
   
        /// PUT DOUBLE FUNCTION ON BUTTON AS IT WAS NOT RUNNINT CORRCTly - now a process of three functions.
         // Loads first so that the rest of the subscription can run.
      // this.getInvoiceItmes(model.invoice_id);
   
   }
   
   
   updateMyobInvoiceModel(model, data_invoice) {
     if (confirm('We are about to Sync and Update Invoice data to MYOB, Are you Sure?')) {
       // console.log('Invoice Data: ' + JSON.stringify(data_invoice));
       
       // :: Ideally need to get a response from insert of the UID of the customer to insert back in sop brands to know th e link has taken place.
       if (this.data_invoice != '{}' ) {
           this._demoService.updateMyobInvoice(this.data_invoice).subscribe(
           data => { this.myobInvoiceUpdatedData = data;
             let res = data[0];
             let new_data_object = JSON.parse(this.myobInvoiceUpdatedData);
       
       
             let location_string = new_data_object.location;
             // get everything after last dash 
             let slug = location_string.split('/').pop(); // 2020
             console.log('UUID slug: ' + slug);
       
                         // model.myob_id = slug;
                         // model.sync_with_myob = 1;
                         // this.updateSubjectInvoice(model);
                         // this.editBrand(model);
                         // this.refreshGrid();
                         // this.toastr.info('Invoice Upgraded In SOP');
       
             // :: Need to lookup myoub get UID/myobid and fill rest of model.vars.
                       // need to pass the brand model here as its updatting the full SOP brand details.
                       this._demoService.getMyobInvoiceMapped(slug, model).subscribe(
                          data4 => {
                           console.log(data4);
                           res = data4[0];
                         // many
                           // this.myobContactListMapped = data.data;
                         //single
                           this.myobInvoiceListMapped = data4;
                         // Set the returned Variables Reququied for Update of a Myob Customer.
                         console.log('UID: ' +  data4.UID);
                         console.log('LastModified: ' + data4.LastModified);
                         console.log('RowVersion: ' + data4.RowVersion);
                         // console.log('TaxCodeUID: ' +  data4.SellingDetails.TaxCode.UID);
                         // console.log('Sale Layout: ' +  data4.SellingDetails.SaleLayout);
   
   
                     // work out the nulls for sub arraryas
                     let CategoryUID;
                     let OrderUID;
                     let SalespersonUID
   
                     if (typeof model.Category === 'undefined' || model.Category === null ) {
                       CategoryUID = null;
                     }else {
                       CategoryUID = model.Category.UID; // can only call if actuall exist in the array!
                     };
                     if (typeof model.Order === 'undefined' || model.Order === null ) {
                       OrderUID = null;
                     }else {
                       OrderUID = model.Category.UID; // can only call if actuall exist in the array!
                     };
                     if (typeof model.Salesperson === 'undefined' || model.Salesperson === null ) {
                       SalespersonUID = null;
                     }else {
                       SalespersonUID = model.Category.UID; // can only call if actuall exist in the array!
                     };
   
   
   
   
   
                         this.set_RowVersion = data4.RowVersion;
                         // model.IsIndividual = data4.IsIndividual;
                         // model.SaleLayout = data4.SellingDetails.SaleLayout;
                         // model.InvoiceDelivery = data4.SellingDetails.InvoiceDelivery;
                         // model.TaxCode = data4.SellingDetails.TaxCode.UID;
                         // model.FreightTaxCode = data4.SellingDetails.FreightTaxCode.UID;
                         model.RowVersion = data4.RowVersion;
                         model.myob_array = JSON.stringify(data4);
                         model.myob_id = slug;
                         model.sync_with_myob = 1;
       
                         
   
   
   
   // All Additional Myon Invoice Variables
   model.UID = data4.UID;
   model.Number = data4.Number;
   model.Date = data4.Date;
   model.CustomerPurchaseOrderNumber = data4.CustomerPurchaseOrderNumber;
   model.CustomerUID = data4.Customer.UID;
   model.CustomerName = data4.Customer.Name;
   model.CustomerDisplayID = data4.Customer.DisplayID;
   model.PromisedDate = data4.PromisedDate;
   model.BalanceDueAmount = data4.BalanceDueAmount;
   model.BalanceDueAmountForeign = data4.BalanceDueAmountForeign;
   model.Status = data4.Status;
   model.TermsPaymentIsDue = data4.Terms.PaymentIsDue;
   model.TermsDiscountDate = data4.Terms.DiscountDate;
   model.TermsBalanceDueDate = data4.Terms.BalanceDueDate;
   model.TermsDiscountForEarlyPayment = data4.Terms.DiscountForEarlyPayment;
   model.TermsMonthlyChargeForLatePayment = data4.Terms.MonthlyChargeForLatePayment;
   model.TermsDiscountExpiryDate = data4.Terms.DiscountExpiryDate;
   model.TermsDiscount = data4.Terms.Discount;
   model.TermsDueDate = data4.Terms.DueDate;
   model.TermsFinanceCharge = data4.Terms.FinanceCharge;
   model.IsTaxInclusive = data4.IsTaxInclusive;
   model.Subtotal = data4.Subtotal;
   model.SubtotalForeign = data4.SubtotalForeign;
   model.Freight = data4.Freight;
   model.FreightForeign = data4.FreightForeign;
   model.FreightTaxCodeUID = data4.FreightTaxCode.UID;
   model.TotalTax = data4.TotalTax;
   model.TotalTaxForeign = data4.TotalTaxForeign;
   model.TotalAmount = data4.TotalAmount;
   model.TotalAmountForeign = data4.TotalAmountForeign;
   model.CategoryUID = CategoryUID; // var
   model.SalespersonUID = SalespersonUID; // var
   model.Comment = data4.Comment;
   model.ShippingMethod = data4.ShippingMethod;
   model.JournalMemo = data4.JournalMemo;
   model.ReferralSource = data4.ReferralSource;
   model.InvoiceDeliveryStatus = data4.InvoiceDeliveryStatus;
   model.LastPaymentDate = data4.LastPaymentDate;
   model.CanApplySurcharge = data4.CanApplySurcharge;
   model.OrderUID = OrderUID; // var
   model.OnlinePaymentMethod = data4.OnlinePaymentMethod;
   model.ForeignCurrency = data4.ForeignCurrency;
   model.CurrencyExchangeRate = data4.CurrencyExchangeRate;
   model.LastModified = data4.LastModified;
   model.URI = data4.URI;
   model.RowVersion = data4.RowVersion;
   
   
   
                  // TOD I NEED TO GET THE LINE ID's and RowVersions to be able to update the Invoice. I THink?
                  // UPDATE the invoice Items RowID, RowVersion and other details.
                      // HERE NOW
   
   
   
                            // ONLY LINES LOOP: go through the data4.Lines[] array to set update model invoice items locally
                            let newArr = Object(data4.Lines).filter((ii)=>(1===1)); // sbi.invoice_status === 'NOT-INVOICED'- old filter
                            let  count_of_items = Object.keys(newArr).length;
                            //  let res = data[0];
                            // Run the job data queries.
                            // need to do a loop of subject_billing items (.length)
                            for(let i=0;i < count_of_items; i++) {
                              let res = newArr[i];
   
                            // empty array of invoiceItemsList first
                            this.invoiceItemsList = {};
   
                              let TaxCodeUID;
                              let JobUID;
                              let AccountUID;
                              let TaxCodeCode;
   
                            console.log('TaxCodeUID:' +  res.TaxCode.UID);
   
                            // check for nulls on sub arrays
                            if (typeof res.TaxCode === 'undefined' || res.TaxCode === null ) {
                            TaxCodeUID = null;
                            TaxCodeCode = null;
                            }else {
                            TaxCodeUID = res.TaxCode.UID; // can only call if actuall exist in the array!
                            TaxCodeCode = res.TaxCode.Code; // can only call if actuall exist in the array!
                            };
                            if (typeof res.Job === 'undefined' || res.Job === null ) {
                            JobUID = null;
                            }else {
                            JobUID = res.Job.UID; // can only call if actuall exist in the array!
                            };
                            if (typeof res.Account === 'undefined' || res.Account === null ) {
                            AccountUID = null;
                            }else {
                            AccountUID = res.Account.UID; // can only call if actuall exist in the array!
                            };
   
                            // so we can insert new items or remove ones that do not exist.
                            // NEW
                            this.invoiceItemsList = { 
                            RowID: res.RowID,
                            Type: res.Type,
                            Description: res.Description,
                            UnitOfMeasure: res.UnitOfMeasure,
                            UnitCount: res.UnitCount,
                            UnitPrice: res.UnitPrice,
                            UnitPriceForeign: res.UnitPriceForeign,
                            DiscountPercent: res.DiscountPercent,
                            Total: res.Total,
                            TotalForeign: res.TotalForeign,
                            AccountUID: AccountUID, // var
                            JobUID: JobUID, // var
                            TaxCodeUID: TaxCodeUID, // var
                            TaxCodeCode: TaxCodeCode, // var
                            RowVersion: res.RowVersion
                                  };
   
                            console.log('InvoiceItemsUpdateModel: ' + JSON.stringify(this.invoiceItemsList));
                            // this.invoiceItemsList = this.invoiceItemsList;
                            if (this.invoiceItemsList !== '{}') {
                              // we udate each item in the loop that was just inserted.
                            this.updateSubjectInvoiceItem(this.invoiceItemsList, model.invoice_id);
                            };
                            } // End Lines Loop
   
   
   
   
   
                         this.updateSubjectInvoice(model);
                         this.toastr.info('Invoice Upgraded In Myob');
                         this.refreshGrid();
                       },
                       error => {
                         // console.error('Error saving Event!');
                          this.toastr.error('Error Updating Invoice to Myob Details');
                         console.log(error.error);
                        });
       
       
                       //  model.RowVersion = this.set_RowVersion;
       
       
                         
                           //  model.RowVersion = this.set_RowVersion;
                       //  model.myob_customer_array = JSON.stringify(this.myobContactListMapped);
       
       
             // let new_data_string = JSON.stringify(this.myobCustomerCreatedData);
             // console.log('new_data date: ' + new_data_string.date);
             // console.log('new_data date: ' + new_data_string.location);
       
             // console.log(this.myobCustomerCreatedData.location);
             // // https://www.concretepage.com/questions/577
             //  this.arrCase = data as object [];  // FILL THE ARRAY WITH DATA.
             //  // console.log(this.arrCase);
             //  this.Items = data['Items'] ;
       
           
           },
           err => {
             // this.toastr.error('You need to login to MYOB again, Connection lost!');
            console.log(err.error);
           },
           // () => console.log('done loading Trace Types')
         );
       }// end if invoice_data
       
         }; // end confirm
       
   
   };
   
  
  
  
  
  
  public getMyobInvoices() {
    this._demoService.getMyobInvoices().subscribe(
      data => { this.myobInvoices = data;
        const res = data[0];
         // https://www.concretepage.com/questions/577
         this.arrCase = data as object [];  // FILL THE ARRAY WITH DATA.
         // console.log(this.arrCase);
         this.Items = data['Items'] ;
         console.log(this.Items);
        // this.Address = this.Items['Address'];
  // return this.myobCustomers;
  
  // Map the data top the new model system
  // this.Items.map(data => data.map(data => new MyobContact().deserialize(data)));
  
      },
      err => {
        // this.toastr.error('You need to login to MYOB again, Connection lost!');
        console.error(err);
      },
      // () => console.log('done loading Trace Types')
    );
  
  }
  
  
  
  deleteMyobServiceInvoicePaymentModel(model){
    // NOT WORKING AS THERE IS NOT ID!
    // lookup the invoices and set a loop model (invoice payments) to update once delted from model.payment_id
    this.getInvoicePaymentsByPaymentID(model.payment_id); // resets the payment item model as its never loaded or used on delete.
// console.log('Ivoices Payment Deleted Effected: ' + JSON.stringify(this.payment_item_model));
this.deleteMyobServiceInvoicePaymentModelStep2(model);
  };
  
  deleteMyobServiceInvoicePaymentModelStep2(model){
    if (confirm('This will delete this Payment and updated Invoices in Myob, Are you Sure?')) {
  this._demoService.deleteMyobPayment(model).subscribe(
      data => { this.myobPaymentDeletedData = data;
        let res = data[0];
        model.myob_id = null;
        model.UID = null;
        model.sync_with_myob = null;
                // All Additional Myon Invoice Payment Variables
                model.UID = null;
                model.DepositTo = null;
                model.AccountUID = null;
                model.CustomerUID = null;
                model.URI = null;
                model.myob_array = null;
                model.RowVersion = null;
                model.myob_id = null;

   



                  // Now Update All invoices Paid.
                  // Mow also need to pull and upate the invoice detauls as a function.
                  let newArr = Object(this.payment_item_model).filter((sbi)=>(1===1)); // sbi.invoice_status === 'NOT-INVOICED'- old filter
                  let  count_of_items = Object.keys(newArr).length;
                  for(let i=0;i < count_of_items; i++) {
                  let inv_res = newArr[i];

                    console.log('Invoice to Update: ' + inv_res.UID);
                  // this.lookupInvoiceUpdateInvoice2(inv_res.myob_id, data);
                  this.lookupInvoiceUpdateInvoice2(inv_res.UID , data);
                  } // end invoices paid that changed.



                  // let newArr = this.payment_item_model.filter((sbi)=>(1===1));
                  // let count_of_items = this.payment_item_model.length;
                  // for(let i=0;i < count_of_items; i++) {
                  //   let inv_res = newArr[i];
                  //   this.lookupInvoiceUpdateInvoice2(this.payment_item_model.myob_id, data);
                  // }


          this.updatePayment(model);

          this.refreshGrid();
        this.toastr.success('Invoice Payments Deleted from with Myob + Invoices Updated Locally.');
      },
      err => {
        // this.toastr.error('You need to login to MYOB again, Connection lost!');
       // console.error(err);
      },
      // () => console.log('done loading Trace Types')
    );
  
    }; // end confirm
  
  };
  
  
  
  
  
  
  public getMyobInvoice(UID){
    this._demoService.getMyobInvoice(UID).subscribe(
      data => { this.myobInvoice = data;
        let res = data[0];
         this.arrCase = data as object [];  // FILL THE ARRAY WITH DATA.
         // console.log(this.arrCase);
         this.invoiceItem = data['Item'] ;
        // console.log(this.customerItem);
        // this.Address = this.Items['Address'];
      },
      err => {
        // this.toastr.error('You need to login to MYOB again, Connection lost!');
        console.error(err);
      },
      // () => console.log('done loading')
    );
  }
  
  
  
  
  
  
  
  updateSubjectInvoice(invoice_model){
    this._demoService.updateSubjectInvoice(invoice_model).subscribe(
      data => {  // this.new_invoice_id = data; // this is the retuned json upon creation.
        // let res = data[0];
      // this.router.navigate(['../../companies'], { relativeTo: this.route });
    this.toastr.success('Local Invoice Updated');
       return true;
      },
      error => {
        console.log(error.error);
     //  this.toastr.error('Adding Failed :: Please try again!');
       // console.log(Observable.throw(error));
        // return Observable.throw(error);
      }
  )
   }
  
  

  
   updateSubjectInvoiceByUID(invoice_model){
    this._demoService.updateSubjectInvoiceByUID(invoice_model).subscribe(
      data => {  // this.new_invoice_id = data; // this is the retuned json upon creation.
        // let res = data[0];
      // this.router.navigate(['../../companies'], { relativeTo: this.route });
    this.toastr.success('Local Invoice Updated');
       return true;
      },
      error => {
        console.log(error.error);
     //  this.toastr.error('Adding Failed :: Please try again!');
       // console.log(Observable.throw(error));
        // return Observable.throw(error);
      }
  )
   }
  










   lookupInvoiceUpdateInvoice(UID, model){

    this._demoService.getMyobInvoiceMapped(UID, model).subscribe(
      data4 => {
       console.log(data4);
       let res = data4[0];
       this.myobInvoiceListMapped = data4;
     // Set the returned Variables Reququied for Update of a Myob Customer.
    //  console.log('UID: ' +  data4.UID);
    console.log('UID: ' +  data4.UID);
    console.log('retInvoiceModel: ' +  JSON.stringify(data4));
  
  // work out the nulls for sub arraryas
  let CategoryUID;
  let OrderUID;
  let SalespersonUID
  
  if (typeof model.Category === 'undefined' || model.Category === null ) {
    CategoryUID = null;
  }else {
    CategoryUID = model.Category.UID; // can only call if actuall exist in the array!
  };
  if (typeof model.Order === 'undefined' || model.Order === null ) {
    OrderUID = null;
  }else {
    OrderUID = model.Category.UID; // can only call if actuall exist in the array!
  };
  if (typeof model.Salesperson === 'undefined' || model.Salesperson === null ) {
    SalespersonUID = null;
  }else {
    SalespersonUID = model.Category.UID; // can only call if actuall exist in the array!
  };
  
  
    this.set_RowVersion = data4.RowVersion;
    // Local data vars.
     model.myob_customer_array = JSON.stringify(data4);
     model.myob_id = data4.UID;
  
     model.UID = data4.UID;
     model.Number = data4.Number;
     model.Date = data4.Date;
     model.CustomerPurchaseOrderNumber = data4.CustomerPurchaseOrderNumber;
     model.CustomerUID = data4.Customer.UID;
     model.CustomerName = data4.Customer.Name;
     model.CustomerDisplayID = data4.Customer.DisplayID;
     model.PromisedDate = data4.PromisedDate;
     model.BalanceDueAmount = data4.BalanceDueAmount;
     model.BalanceDueAmountForeign = data4.BalanceDueAmountForeign;
     model.Status = data4.Status;
     model.TermsPaymentIsDue = data4.Terms.PaymentIsDue;
     model.TermsDiscountDate = data4.Terms.DiscountDate;
     model.TermsBalanceDueDate = data4.Terms.BalanceDueDate;
     model.TermsDiscountForEarlyPayment = data4.Terms.DiscountForEarlyPayment;
     model.TermsMonthlyChargeForLatePayment = data4.Terms.MonthlyChargeForLatePayment;
     model.TermsDiscountExpiryDate = data4.Terms.DiscountExpiryDate;
     model.TermsDiscount = data4.Terms.Discount;
     model.TermsDueDate = data4.Terms.DueDate;
     model.TermsFinanceCharge = data4.Terms.FinanceCharge;
     model.IsTaxInclusive = data4.IsTaxInclusive;
     model.Subtotal = data4.Subtotal;
     model.SubtotalForeign = data4.SubtotalForeign;
     model.Freight = data4.Freight;
     model.FreightForeign = data4.FreightForeign;
     model.FreightTaxCodeUID = data4.FreightTaxCode.UID;
     model.TotalTax = data4.TotalTax;
     model.TotalTaxForeign = data4.TotalTaxForeign;
     model.TotalAmount = data4.TotalAmount;
     model.TotalAmountForeign = data4.TotalAmountForeign;
     model.CategoryUID = CategoryUID; // var
     model.SalespersonUID = SalespersonUID; // var
     model.Comment = data4.Comment;
     model.ShippingMethod = data4.ShippingMethod;
     model.JournalMemo = data4.JournalMemo;
     model.ReferralSource = data4.ReferralSource;
     model.InvoiceDeliveryStatus = data4.InvoiceDeliveryStatus;
     model.LastPaymentDate = data4.LastPaymentDate;
     model.CanApplySurcharge = data4.CanApplySurcharge;
     model.OrderUID = OrderUID; // var
     model.OnlinePaymentMethod = data4.OnlinePaymentMethod;
     model.ForeignCurrency = data4.ForeignCurrency;
     model.CurrencyExchangeRate = data4.CurrencyExchangeRate;
     model.LastModified = data4.LastModified;
     model.URI = data4.URI;
     model.RowVersion = data4.RowVersion;
  
  
    //  this.updateSubjectInvoice(model);
     // update invoice itemes? to do Done BELOW... by description! to set row IDS
  
    // create a lines model with all new data and upate existing invoice_items.
  
  
  // ONLY LINES LOOP: go through the data4.Lines[] array to set update model invoice items locally
    let newArr = Object(data4.Lines).filter((ii)=>(1===1)); // sbi.invoice_status === 'NOT-INVOICED'- old filter
    let  count_of_items = Object.keys(newArr).length;
    //  let res = data[0];
    // Run the job data queries.
    // need to do a loop of subject_billing items (.length)
    for(let i=0;i < count_of_items; i++) {
      let res = newArr[i];
  
    // empty array of invoiceItemsList first
    this.invoiceItemsList = {};
  
      let TaxCodeUID;
      let JobUID;
      let AccountUID;
      let TaxCodeCode;
  
  console.log('TaxCodeUID:' +  res.TaxCode.UID);
  
  // check for nulls on sub arrays
  if (typeof res.TaxCode === 'undefined' || res.TaxCode === null ) {
    TaxCodeUID = null;
    TaxCodeCode = null;
  }else {
    TaxCodeUID = res.TaxCode.UID; // can only call if actuall exist in the array!
    TaxCodeCode = res.TaxCode.Code; // can only call if actuall exist in the array!
  };
  if (typeof res.Job === 'undefined' || res.Job === null ) {
    JobUID = null;
  }else {
    JobUID = res.Job.UID; // can only call if actuall exist in the array!
  };
  if (typeof res.Account === 'undefined' || res.Account === null ) {
    AccountUID = null;
  }else {
    AccountUID = res.Account.UID; // can only call if actuall exist in the array!
  };
  
  this.invoiceItemsList = {
    RowID: res.RowID,
    Type: res.Type,
    Description: res.Description,
    UnitOfMeasure: res.UnitOfMeasure,
    UnitCount: res.UnitCount,
    UnitPrice: res.UnitPrice,
    UnitPriceForeign: res.UnitPriceForeign,
    DiscountPercent: res.DiscountPercent,
    Total: res.Total,
    TotalForeign: res.TotalForeign,
    AccountUID: AccountUID, // var
    JobUID: JobUID, // var
    TaxCodeUID: TaxCodeUID, // var
    TaxCodeCode: TaxCodeCode, // var
    RowVersion: res.RowVersion
          };
    
    console.log('InvoiceItemsUpdateModel: ' + JSON.stringify(this.invoiceItemsList));
    // this.invoiceItemsList = this.invoiceItemsList;
    if (this.invoiceItemsList !== '{}') {
    
      // this.updateSubjectInvoiceItem(this.invoiceItemsList, model.invoice_id);
    };
    } // End Lines Loop
  
  
     this.toastr.info('Invoice Vrs Updated In SOP');
     // now finally update the invoice
     this.updateSubjectInvoice(model);
        this.refreshGrid();
   },
   error => {
     // console.error('Error saving Event!');
      this.toastr.error('Error Collecting Invoice Myob Details');
     console.log(error.error);
    });
  }; // end loopup and update function












  
  
   lookupInvoiceUpdateInvoice2(UID, model){
    this._demoService.getMyobInvoiceMapped(UID, model).subscribe(
      data4 => {
       console.log(data4);
       let res = data4[0];
       this.myobInvoiceListMapped = data4;
     // Set the returned Variables Reququied for Update of a Myob Customer.
    //  console.log('UID: ' +  data4.UID);
    console.log('UID: ' +  data4.UID);
    // console.log('retInvoiceModel: ' +  JSON.stringify(data4));
  
 const sent_invoice_id = UID;
//  const sent_real_invoice_id = model.invoice_id;


this.invoice_model = {}; // clear the invoice moddl.
  
  // work out the nulls for sub arraryas
  let CategoryUID;
  let OrderUID;
  let SalespersonUID
  
  if (typeof model.Category === 'undefined' || model.Category === null ) {
    CategoryUID = null;
  }else {
    CategoryUID = model.Category.UID; // can only call if actuall exist in the array!
  };
  if (typeof model.Order === 'undefined' || model.Order === null ) {
    OrderUID = null;
  }else {
    OrderUID = model.Category.UID; // can only call if actuall exist in the array!
  };
  if (typeof model.Salesperson === 'undefined' || model.Salesperson === null ) {
    SalespersonUID = null;
  }else {
    SalespersonUID = model.Category.UID; // can only call if actuall exist in the array!
  };



    this.set_RowVersion = data4.RowVersion;
    // Local data vars.
    //  model.myob_array = JSON.stringify(data4);
    //  model.myob_id = data4.UID;
  
    //  model.UID = data4.UID;
    //  model.Number = data4.Number;
    //  model.Date = data4.Date;
    //  model.CustomerPurchaseOrderNumber = data4.CustomerPurchaseOrderNumber;
    //  model.CustomerUID = data4.Customer.UID;
    //  model.CustomerName = data4.Customer.Name;
    //  model.CustomerDisplayID = data4.Customer.DisplayID;
    //  model.PromisedDate = data4.PromisedDate;
    //  model.BalanceDueAmount = data4.BalanceDueAmount;
    //  model.BalanceDueAmountForeign = data4.BalanceDueAmountForeign;
    //  model.Status = data4.Status;
    //  model.TermsPaymentIsDue = data4.Terms.PaymentIsDue;
    //  model.TermsDiscountDate = data4.Terms.DiscountDate;
    //  model.TermsBalanceDueDate = data4.Terms.BalanceDueDate;
    //  model.TermsDiscountForEarlyPayment = data4.Terms.DiscountForEarlyPayment;
    //  model.TermsMonthlyChargeForLatePayment = data4.Terms.MonthlyChargeForLatePayment;
    //  model.TermsDiscountExpiryDate = data4.Terms.DiscountExpiryDate;
    //  model.TermsDiscount = data4.Terms.Discount;
    //  model.TermsDueDate = data4.Terms.DueDate;
    //  model.TermsFinanceCharge = data4.Terms.FinanceCharge;
    //  model.IsTaxInclusive = data4.IsTaxInclusive;
    //  model.Subtotal = data4.Subtotal;
    //  model.SubtotalForeign = data4.SubtotalForeign;
    //  model.Freight = data4.Freight;
    //  model.FreightForeign = data4.FreightForeign;
    //  model.FreightTaxCodeUID = data4.FreightTaxCode.UID;
    //  model.TotalTax = data4.TotalTax;
    //  model.TotalTaxForeign = data4.TotalTaxForeign;
    //  model.TotalAmount = data4.TotalAmount;
    //  model.TotalAmountForeign = data4.TotalAmountForeign;
    //  model.CategoryUID = CategoryUID; // var
    //  model.SalespersonUID = SalespersonUID; // var
    //  model.Comment = data4.Comment;
    //  model.ShippingMethod = data4.ShippingMethod;
    //  model.JournalMemo = data4.JournalMemo;
    //  model.ReferralSource = data4.ReferralSource;
    //  model.InvoiceDeliveryStatus = data4.InvoiceDeliveryStatus;
    //  model.LastPaymentDate = data4.LastPaymentDate;
    //  model.CanApplySurcharge = data4.CanApplySurcharge;
    //  model.OrderUID = OrderUID; // var
    //  model.OnlinePaymentMethod = data4.OnlinePaymentMethod;
    //  model.ForeignCurrency = data4.ForeignCurrency;
    //  model.CurrencyExchangeRate = data4.CurrencyExchangeRate;
    //  model.LastModified = data4.LastModified;
    //  model.URI = data4.URI;
    //  model.RowVersion = data4.RowVersion;
  

     
// make the function more universal? or make custom by itself?
     this.invoice_model = {
      myob_array: JSON.stringify(data4),
      myob_id: data4.UID,
      UID: data4.UID,
      Number: data4.Number,
      Date: data4.Date,
      CustomerPurchaseOrderNumber: data4.CustomerPurchaseOrderNumber,
      CustomerUID: data4.Customer.UID,
      CustomerName: data4.Customer.Name,
      CustomerDisplayID: data4.Customer.DisplayID,
      PromisedDate: data4.PromisedDate,
      BalanceDueAmount: data4.BalanceDueAmount,
      BalanceDueAmountForeign: data4.BalanceDueAmountForeign,
      Status: data4.Status,
      TermsPaymentIsDue: data4.Terms.PaymentIsDue,
      TermsDiscountDate: data4.Terms.DiscountDate,
      TermsBalanceDueDate: data4.Terms.BalanceDueDate,
      TermsDiscountForEarlyPayment: data4.Terms.DiscountForEarlyPayment,
      TermsMonthlyChargeForLatePayment: data4.Terms.MonthlyChargeForLatePayment,
      TermsDiscountExpiryDate: data4.Terms.DiscountExpiryDate,
      TermsDiscount: data4.Terms.Discount,
      TermsDueDate: data4.Terms.DueDate,
      TermsFinanceCharge: data4.Terms.FinanceCharge,
      IsTaxInclusive: data4.IsTaxInclusive,
      Subtotal: data4.Subtotal,
      SubtotalForeign: data4.SubtotalForeign,
      Freight: data4.Freight,
      FreightForeign: data4.FreightForeign,
      FreightTaxCodeUID: data4.FreightTaxCode.UID,
      TotalTax: data4.TotalTax,
      TotalTaxForeign: data4.TotalTaxForeign,
      TotalAmount: data4.TotalAmount,
      TotalAmountForeign: data4.TotalAmountForeign,
      CategoryUID: CategoryUID, // var
      SalespersonUID: SalespersonUID, // var
      Comment: data4.Comment,
      ShippingMethod: data4.ShippingMethod,
      JournalMemo: data4.JournalMemo,
      ReferralSource: data4.ReferralSource,
      InvoiceDeliveryStatus: data4.InvoiceDeliveryStatus,
      LastPaymentDate: data4.LastPaymentDate,
      CanApplySurcharge: data4.CanApplySurcharge,
      OrderUID: OrderUID, // var
      OnlinePaymentMethod: data4.OnlinePaymentMethod,
      ForeignCurrency: data4.ForeignCurrency,
      CurrencyExchangeRate: data4.CurrencyExchangeRate,
      LastModified: data4.LastModified,
      URI: data4.URI,
      RowVersion: data4.RowVersion,
      // invoice_id: data4.invoice_id // needed for update quiery.
      invoice_id: sent_invoice_id // set manuall and test.
            };

    //   console.log('InvoiceItemsUpdateModel: ' + JSON.stringify(this.invoiceItemsList));
    //   // this.invoiceItemsList = this.invoiceItemsList;
    //   if (this.invoiceItemsList !== {}) {
    //     // we udate each item in the loop that was just inserted.
    //   this.updateSubjectInvoiceItem(this.invoiceItemsList, model.invoice_id);
    //   };


// this.invoice_model = this.invoice_model;
// this.updateSubjectInvoice(this.invoice_model); // changed so that UID instead of invoice ID
this.updateSubjectInvoiceByUID(this.invoice_model);

  // create a lines model with all new data and upate existing invoice_items
  // ONLY LINES LOOP: go through the data4.Lines[] array to set update model invoice items locally
    let newArr = Object(data4.Lines).filter((ii)=>(1===1)); // sbi.invoice_status === 'NOT-INVOICED'- old filter
    let  count_of_items = Object.keys(newArr).length;
    //  let res = data[0];
    // Run the job data queries.
    // need to do a loop of subject_billing items (.length)
    for(let i=0;i < count_of_items; i++) {
      let res = newArr[i];
  
    // empty array of invoiceItemsList first
    this.invoiceItemsList = {};
  
      let TaxCodeUID;
      let JobUID;
      let AccountUID;
      let TaxCodeCode;
  
  // console.log('TaxCodeUID:' +  res.TaxCode.UID);
  
  // check for nulls on sub arrays
  if (typeof res.TaxCode === 'undefined' || res.TaxCode === null ) {
    TaxCodeUID = null;
    TaxCodeCode = null;
  }else {
    TaxCodeUID = res.TaxCode.UID; // can only call if actuall exist in the array!
    TaxCodeCode = res.TaxCode.Code; // can only call if actuall exist in the array!
  };
  if (typeof res.Job === 'undefined' || res.Job === null ) {
    JobUID = null;
  }else {
    JobUID = res.Job.UID; // can only call if actuall exist in the array!
  };
  if (typeof res.Account === 'undefined' || res.Account === null ) {
    AccountUID = null;
  }else {
    AccountUID = res.Account.UID; // can only call if actuall exist in the array!
  };
  
  this.invoiceItemsList = {
    RowID: res.RowID,
    Type: res.Type,
    Description: res.Description,
    UnitOfMeasure: res.UnitOfMeasure,
    UnitCount: res.UnitCount,
    UnitPrice: res.UnitPrice,
    UnitPriceForeign: res.UnitPriceForeign,
    DiscountPercent: res.DiscountPercent,
    Total: res.Total,
    TotalForeign: res.TotalForeign,
    AccountUID: AccountUID, // var
    JobUID: JobUID, // var
    TaxCodeUID: TaxCodeUID, // var
    TaxCodeCode: TaxCodeCode, // var
    RowVersion: res.RowVersion
          };
    
    // console.log('InvoiceItemsUpdateModel: ' + JSON.stringify(this.invoiceItemsList));
    // this.invoiceItemsList = this.invoiceItemsList;
    if (this.invoiceItemsList !== '{}') {
    this.updateSubjectInvoiceItem(this.invoiceItemsList, this.invoice_model.invoice_id);
    };
    } // End Lines Loop
  
  
     this.toastr.info('Invoice Vrs Updated In SOP');
     // now finally update the invoice
    //  this.updateSubjectInvoice(model);
        this.refreshGrid();
   },
   error => {
     // console.error('Error saving Event!');
      this.toastr.error('Error Collecting Invoice Myob Details');
     console.log(error.error);
    });
  }; // end loopup and update function
  
  
  
  
   // Get Invoice Items - Normal get
   getInvoiceItems(invoice_id){
    this._demoService.getSubjectInvoiceItems(invoice_id).subscribe(
      (data) => {
        this.invoiceItemsList = data;
        let res = data[0];
        this.invoice_item_model = this.invoiceItemsList;
        // this.setMyobInvoiceModelStep2(model); // ru
        // this.updateMyobInvoiceModelStep2(model);
        // this.doCalculations();
      },
      (err) => console.error(err),
     () => console.log('Invoice Items Loaded.')
    )};
  


    deleteMyobPaymentDirect(model){
  if (confirm('Are you sure you wish to remove this credit from myob?')) {
      
      this.gfunc.myobChecker();
    this._demoService.deleteMyobPaymentDirect(model)
    .pipe(
      retry(1), // you retry 3 times
      delay(1500) // each retry will start after 1 second,
   )
    .subscribe(
        data => { this.myobPaymentDeletedData = data;
          let res = data[0];
          
          this.toastr.success("Credit/Payment Removed From MYOB")
          this.refreshGrid();
        },
        (err) => console.error(err),
       () => console.log('Invoice Items Loaded.')
      )
      }
    };
  
  
    updateSubjectInvoiceItem(model, invoice_id){
      this._demoService.updateSubjectInvoiceItemByDescription(model, invoice_id).subscribe(
        data => {  // this.new_invoice_id = data; // this is the retuned json upon creation.
          // let res = data[0];
        // this.router.navigate(['../../companies'], { relativeTo: this.route });
         return true;
        },
        error => {
          console.error(error);
       //  this.toastr.error('Adding Failed :: Please try again!');
         // console.log(Observable.throw(error));
          // return Observable.throw(error);
        }
    )
     }
  
  
  editBrand(model){
    // model.job_id = this.job_id;
     this._demoService.updateBrand(model).subscribe(
       data => {  // this.trace_candidate_update = data;
         // refresh the list
        // this.getTraceCandidate(this.model.trace_candidate_id);  // created bugs...
       this.toastr.success('Company Updated');
       this.gfunc.insertLog_UpdateCompany(model); // hadled in the global functions file.
      // this.router.navigateByUrl('admin/clients', {skipLocationChange: true}).then(() =>
      // this.router.navigate(['/admin/jobs/subject/edit/' + model.subject_id + '']));
       },
       error => {
        // console.error('Error saving Event!');
         this.toastr.error('Error Updating Brand');
        return console.log(error);
       }
      // err => console.error(err),
      // () => console.log('done updates')
   );}
  
  
   public getMyobCustomerPaymerntsLive() {
    return  this._demoService.getMyobCustomerPaymerntsLive().subscribe(
        data => { this.myob_payments_live = data;
          const res = data[0];
           // https://www.concretepage.com/questions/577
           this.arrCase = data as object [];  // FILL THE ARRAY WITH DATA.
           // console.log(this.arrCase);
           this.Items = data['Items'] ;
           this.sent_data = this.Items;
          //  this.sent_data_stringify = JSON.stringify(this.sent_data);
  
           // console.log(this.Items);
          // this.Address = this.Items['Address'];
    // return this.myobCustomers;
  


     // non of these worked correctly

// THe rule is keep the latest and always remove the earliest.
// Filter by invoice number



     // 
    // Map the data top the new model system
   // this.Items.map(data => data.map(data => new MyobContact().deserialize(data)));

          // Filters
   const InvoicePaymentsFiltered = Object(this.sent_data).filter((ac) => (ac.Invoices[0].Number === this.invoice_number)); 
   this.sent_data = InvoicePaymentsFiltered;
            // Filter the Objects... If invoice_number = this invoice_number // Show Payments
            //  -- and invoice_payment_UID == invoice payment id locally -- mark as joined...
            // otherwise -- mark as an "OVER PAYMENT if no link back......."


            // Build two models the same and compare the difference like I have writtent the function below.
              // Difference compares arrays so I make a simple arrays out of datas to compare... then show difference.
            const payments_data = [
            this.payments.myob_id
             ]

            const myob_payments_data = [
             this.sent_data.UID
            ]


         const difference_data =   _.difference( [...this.sent_data], [...this.payments]);
         this.difference_payment_data = difference_data;

        //  const difference_data =   _.difference( payments_data, myob_payments_data);
        //  this.difference_payment_data = difference_data;

            
  
        },
        err => {
          // this.toastr.error('You need to login to MYOB again, Connection lost!');
         // console.error(err);
        },
        // () => console.log('done loading Trace Types')
      );
  
    }
  
  
  }